import React from "react";
import { Modal, Button } from "react-bootstrap";
import RestartIcon from "assets/images/images_new/Restart-icon.svg";

const Confirm = ({
  status,
  confirm,
  yesLabel,
  noLabel,
  title,
  toggle,
  message,
}) => {
  return (
    <Modal show={status} centered size="md" className="text-translate-modal">
      <Modal.Header className="d-flex">
        <Modal.Title className="text-translation popup_heading m-0 gap-2">
          {title === 'Restart Question?' && 
          <div className="modal-header-img">
            <img src={RestartIcon} alt="multi-languages" />
          </div>
          }
          {title}
        </Modal.Title>

        <Button
          variant="link"
          className="modalClose-Btn p-0"
          onClick={() => toggle()}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            width="24"
            height="24"
          >
            <path
              d="M18 6L6 18M6 6l12 12"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </Button>
      </Modal.Header>
      <Modal.Body>
        <div className="p-2">{message}</div>
      </Modal.Body>
      <Modal.Footer>
        <button className="btn close-button" onClick={confirm}>
          {yesLabel}
        </button>
        <button className="outline-btn" onClick={() => toggle()}>
          {noLabel}
        </button>
      </Modal.Footer>
    </Modal>
  );
};

export default Confirm;
